export default "__VITE_ASSET__f_L6Qd6N__"